'use strict';
(
  function (window, document, _, bs, undefined) {
    'use strict';

    function checkEmailValidity(e) {
      if (e.target.reportValidity()) {
        e.target.classList.remove('is-invalid');
        e.target.classList.add('is-valid');
      }
    }

    function resetMailChimpForm() {
      /** @type {HTMLFormElement|null} */
      const mcForm = document.getElementById('mc-embedded-subscribe-form');

      if (mcForm instanceof HTMLFormElement) {
        /** @type {HTMLInputElement|null} */
        const mcEmailField = mcForm.querySelector(':scope input[type=email]');

        mcForm.reset();

        if (mcEmailField instanceof HTMLInputElement) {
          mcEmailField.classList.remove('is-invalid');
          mcEmailField.classList.remove('is-valid');
          mcEmailField.removeEventListener('change', checkEmailValidity, { once: true });
          mcEmailField.removeEventListener('blur', checkEmailValidity, { once: true });
        }
      }
    }

    function markInputInvalid(e) {
      const input = e.target;

      if (input instanceof HTMLInputElement) {
        input.classList.add('is-invalid');
        input.classList.remove('is-valid');
        input.addEventListener('change', checkEmailValidity, { once: true });
        input.addEventListener('blur', checkEmailValidity, { once: true });
      }
    }

    function addMailChimpListeners() {
      /** @type {HTMLFormElement|null} */
      const mcForm = document.getElementById('mc-embedded-subscribe-form');

      if (mcForm instanceof HTMLFormElement) {
        /** @type {HTMLDivElement|null} */
        const mcFormModal = mcForm.closest('div.modal'),
          /** @type {HTMLInputElement|null} */
          mcEmailField = mcForm.querySelector(':scope input[type=email]');

        if (mcFormModal instanceof HTMLDivElement) {
          mcFormModal.addEventListener('hide.bs.modal', resetMailChimpForm);
        }

        if (mcEmailField instanceof HTMLInputElement) {
          mcEmailField.addEventListener('invalid', markInputInvalid);
        }
      }
    }

    document.addEventListener('DOMContentLoaded', addMailChimpListeners);
  }
)(window, document, window.lodash, bootstrap);
